import { render, staticRenderFns } from "./VideoReplybox.vue?vue&type=template&id=8da64100&scoped=true&"
import script from "./VideoReplybox.vue?vue&type=script&lang=js&"
export * from "./VideoReplybox.vue?vue&type=script&lang=js&"
import style0 from "./VideoReplybox.vue?vue&type=style&index=0&id=8da64100&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da64100",
  null
  
)

export default component.exports